import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';

import { DialogContext } from '../context/DialogContext.js';

function LabelSpeedDial({ label }) {
  const { dialogStates, openDialog, closeDialog } = React.useContext(DialogContext);
  // console.log(label)

  return (
    <Box>
        <SpeedDial
          ariaLabel={`${label.name}SpeedDial`}
          direction="left"
          icon={label.mainIcon}
        >
          {/* Existing nodes */}
            {/* <SpeedDialAction
              key={node.name}
              icon={node.icon}
              tooltipTitle={node.name}
              onClick={node.onClick}
            /> */}

          {/* Add new node */}
          <SpeedDialAction
            icon={label.addIcon}
            tooltipTitle={`Add ${label.name}`}
            onClick={() => onAdd(label)}
          />
        </SpeedDial>
    </Box>
  );
}

export default LabelSpeedDial;
